import { Buffer } from 'buffer';
import { parse, format as dateFnsFormat } from 'date-fns';

import { isValidMMDDYYYYDate } from './stringValidators';

export const stringToBase64 = (data: string): string => (
  Buffer.from(data).toString('base64')
);

export const base64ToString = (data: string): string => (
  Buffer.from(data, 'base64').toString('ascii')
);

export const convertDOBToDateString = (date: string) => {
  if (isValidMMDDYYYYDate(date)) {
    const dateArr = date.split('/');
    const day = parseInt(dateArr[1], 10);
    const month = parseInt(dateArr[0], 10) - 1;
    const year = parseInt(dateArr[2], 10);
    const UTCDate = new Date(year, month, day);
    const offset = UTCDate.getTimezoneOffset() * 60000;
    return new Date(UTCDate.getTime() - offset).toISOString();
  }
  return `${date} was not able to be parsed into a Date string`;
};

export const parseSearchParams = (search: string) => {
  const searchParams = new URLSearchParams(search);
  const params: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
};

export const parseDate = (dateString: string) => {
  const strippedDate = dateString.split(' ').join('');
  return parse(strippedDate, 'MM/dd/yyyy', new Date());
};

export const formatDateString = (dateString: string, format = 'yyyy-MM-dd') => {
  const parsedDate = parseDate(dateString);
  return dateFnsFormat(parsedDate, format);
};

// Folds only visually equivalent punctuation, so case and diacritics still distinguish names.
export const normalizeForEligibilityMatch = (value: string): string => value
  .replace(/[‘’‚‛′‵]/g, "'")
  .replace(/[“”„‟″‶]/g, '"')
  .replace(/[‐-―−]/g, '-')
  .replace(/\s+/g, ' ')
  .trim();
